import Swiper, {Navigation} from "swiper";

const wrapper = document.querySelector('.products-slider-wrapper');
const sliderEl = wrapper?.querySelector('.products-slider');

if (sliderEl) {
    new Swiper(sliderEl, {
        slidesPerView: 1,
        loop: true,
        touchRatio: 0.1,
        centeredSlides: true,
        navigation: {
            prevEl: wrapper.querySelector('.swiper-button-prev'),
            nextEl: wrapper.querySelector('.swiper-button-next'),
        },
        modules: [Navigation],
    });
}
